import { Attrs, MinzeElement } from "minze";

export class TjError extends MinzeElement {
  attrs: Attrs = [
    ["error", false],
  ];

  static observedAttributes = [
    "error",
  ];

  html = () => {
    if (!this.error) return ``;
    return `<p class="error-label">${this.error}</p>`;
  }
  css = () => {

    return `
    .error-label {
      color: #DF374B;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin: 4px 0 0;
    }
  `};
}
